<template>
    <div class="container" style="width: 100vw; height: 100vh;">
    <div style="margin-top: -30px;">
    <span class="text-danger fs-3 fw-bold">LTC Red Army</span>
    <br>
    <span class="fs-5 fw-bold" style="color:rgb(25, 43, 145)">(Questions and Choices <i class="fa fa-gear"></i>)</span>
    </div>
        <div class="row" style="padding: 50px 5px 0px 5px">
                      <div class="col-4 " style="background-color: #EAEDED;height: 35px;padding: 5px 0px 0px 0px;border-radius: 2px;">
                          <label for="username" class="form-label " >
                          <span class="fw-bold " style="font-size: 12px;">Survey group</span>
                        </label>
                      </div>
                      <div class="col-8 " style="height: 35px;">
                        <button style="height: 35px;width:100%" class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                          <span style="font-size: 12px;">{{ selectedSurveyGroupData.id==-9999?"Please select": selectedSurveyGroupData.name_la}}</span>
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style="font-size: 12px;">
                          <li v-for="(groupData,index) in surveyGroupDdl" v-bind:key="index" @click="getQuestionsAndChoices(groupData);">&nbsp;{{groupData.name_la}}&nbsp;</li>
                        </ul>
                  </div>
        </div>        
        <div class="row" style="padding: 3px 5px 0px 5px;height: 60vh;overflow-y: scroll;">
        <table class="table table-striped" style="width:100%;">
          <thead>
            <tr style="background-color:cornflowerblue">
              <th scope="col-2" style="border:1px solid black;padding-bottom:15px">No.</th>
              <th scope="col-10" style="border:1px solid black;">
                <div class="row">
                  <div class="col-9" style="padding-top:5px;font-size: 12px;">
                    Questions
                  </div>
                  <div class="col-3 text-end">
                    <button v-if="selectedSurveyGroupData.id!=-9999" type="button" class="btn btn-success" @click="clickBtnAddQuestion();">
                      <i class="fa-solid fa-plus"></i>
                    </button>
                  </div>                
              </div>
              </th>
            </tr>
          </thead>
          <tbody >
            <tr v-for="(questionData, index) in surveyObject['surveyGroup'+selectedSurveyGroupData.id]" v-bind:key="index"
            @click="clickRowQuestion(questionData,index+1,questionData.q_province_code);">
              <td style="border:1px solid black">{{ index+1 }}</td>
              <td class="text-start" style="border:1px solid black;font-size: 12px;">
                {{questionData.question_msg_la}}<br>
                <i class="fas fa-clock"></i>{{dateStrFormat(questionData.create_date)}}
                <i class="fa-regular fa-clock"></i>{{dateStrFormat(questionData.last_modify_date)}}
                <br>
                <i v-if="questionData.status&&questionData.status!=0" class="fa-solid fa-check" style="color:green"></i>
                <i v-else class="fa-solid fa-xmark" style="color:red"></i>
                {{questionData.status&&questionData.status!=0?'Active':'Inactive'}}
              </td>
            </tr>
          </tbody>
       </table>
      </div>

<!-- MODAL MODIFY QUESTION -->
<div class="modal fade" id="modalQDetail" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-fullscreen-sm-down" >
    <div class="modal-content" >
      <div class="modal-header">
          <b>{{modalQDetailFlagSwicthEdit?'Edit question':(modalQDetailFlagSwicthEdit==null?'Adding Question and Choice':'Question Details')}}</b>
        &nbsp;
        <i class="fas fa-pen-to-square" @click="modalQDetailFlagSwicthEdit==true?modalQDetailFlagSwicthEdit=false:modalQDetailFlagSwicthEdit=true"></i>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body" :style='!modalQDetailFlagSwicthEdit&&modalQDetailFlagSwicthEdit!=null?{"pointer-events": "none","opacity": "0.4"}: {}'>
        <!-- section1 -->
        <div>  
          <div class="row" style="padding-top:3px;height:35px;">
              <div class="input-group mb-3">
                <span class="input-group-text" style="font-size: 12px;">Question No.</span>
                <span class="input-group-text" style="font-size: 12px;">
                  {{ modalRowNumber }}
                </span>
              </div>
          </div>
          <div class="row" style="padding-top:3px;height:35px;">
              <div class="input-group mb-3">
                <span class="input-group-text" style="font-size: 12px;">Customer Type</span>
                <span class="input-group-text" style="font-size: 12px;">
                  {{ selectedSurveyGroupData.name_la }}
                </span>
              </div>
          </div>

          <div class="row" style="padding-top: 3px;">
            <div class="col-12 text-start">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" v-model="modalQDetailQuestionStatus" value="true" >
                <label class="form-check-label" for="inlineRadio1" style="font-size: 12px;">Active</label>
              </div>
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" name="inlineRadioOptions" v-model="modalQDetailQuestionStatus" value="false">
                <label class="form-check-label" for="inlineRadio2" style="font-size: 12px;">Inactive</label>
              </div>
            </div>
          </div>

          <div class="row" style="padding-top:3px;">
              <div class="input-group mb-3">
                <span class="input-group-text" style="font-size: 12px;">Question Message</span>
                <textarea class="form-control" v-model="modalQDetailQuestionMsg" style="height: 60px;font-size: 12px;">Question number 1?</textarea>
              </div>
          </div>
          </div>
          <!-- section2 -->
          <div  style="margin-bottom: -20px">
              <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col" style="width: 15%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">No.</th>
                  <th scope="col" style="width: 75%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">Choice Message</th>
                  <th scope="col" style="width: 10%;font-size: 12px;border:1px solid black;text-align: left;background-color: cornflowerblue;">
                   
                    <button type="button" class="btn btn-success" @click="clickAddChoice();">
                      <i class="fa-solid fa-plus"></i>
                    </button>
                    <br>
                    Single 
                  </th>
                </tr>
              </thead>
              <tbody >
                <tr v-for="(modalChoice, index) in modalQDetailChoices" v-bind:key="index">
                  <th scope="row" style="font:12px;border:1px solid black;">
                    <i class="fa-solid fa-square-minus" style="color: red;" @click="clickDeleteChoice(index,modalChoice.c_id,modalChoice.choice_msg_la)"></i> 
                    {{index+1}}
                  </th>
                  <td style="padding:0px;border:1px solid black;">
                    <input type="text" class="form-control" v-model="modalChoice.choice_msg_la" style="height: 35px;">
                  </td>
                  <td class="text-center" style="padding:0px;border:1px solid black;">
                      <input class="form-check-input" type="checkbox" id="flexCheckDefault" v-model="modalChoice.is_single_choice">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr>
          <!-- section3 -->
          <!-- <div style="width: 100%;">
          <span style="font-size: 12px;float: left;"><b>Question Area</b></span>
              <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col" style="width: 15%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">No.</th>
                  <th scope="col" style="width: 85%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">
                    <span>Province</span>
                    <button type="button" style="float: right;" class="btn btn-success" @click="clickBtnAddProvince();">
                      <i class="fa-solid fa-plus"></i>
                    </button> 
                  </th>
                </tr>
              </thead>
              <tbody >
                <tr v-for="(questionArea, index) in modalQDetailProvince" v-bind:key="index">
                  <td style="font:12px;border:1px solid black;">
                    <i class="fa-solid fa-square-minus" style="color: red;" @click="clickDeleteProvince(index,questionArea)"></i> 
                    {{index+1}}
                  </td>
                  <td style="padding:0px;border:1px solid black;" @click="modalAreaFlagAdd=false;clickRowProvince(questionArea.province_code,questionArea.districts_id);">
                    <span style="font-size: 12px;"> {{ questionArea.province_code+', '+questionArea.name_la+'/'+questionArea.name_en}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div> -->
       

       

          
      </div>
      <div class="modal-footer">
        <button @click="clickBtnDeleteQuestion();" v-if="modalQDetailFlagSwicthEdit&&modalQDetailFlagSwicthEdit!=null" type="button" class="btn btn-danger" data-bs-dismiss="modal">Delete</button>
        <button v-if="modalQDetailFlagSwicthEdit||modalQDetailFlagSwicthEdit==null" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button @click="clickSave()" v-if="modalQDetailFlagSwicthEdit||modalQDetailFlagSwicthEdit==null" type="button" class="btn btn-primary">Save</button>
      </div>
    </div>
  </div>
</div>

<!-- MODAL MODIFY QUESTION AREA -->
<div class="modal fade" id="modalArea" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-scrollable modal-fullscreen-sm-down" >
    <div class="modal-content" >
      <div class="modal-header">
        <!-- <h7 class="modal-title" id="exampleModalLabel"> -->
          <b>Edit Area to question</b>
        <!-- </h7> -->
        &nbsp;
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <!-- section1 -->
        <div>  
          <div class="row" style="padding: 50px 5px 0px 5px" :style='modalAreaFlagAdd?{}:{"pointer-events": "none","opacity": "0.4"}'>
              <div class="col-4 " style="background-color: #EAEDED;height: 35px;padding: 5px 0px 0px 0px;border: 1px solid black;border-radius: 2px;">
                    <label for="username" class="form-label " >
                      <span class="fw-bold " style="font-size: 12px;">Province</span>
                    </label>
              </div>
              <div class="col-8 " style="height: 35px;">
                    <button style="height: 35px;width:100%" class="btn btn-light dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                          <span style="font-size: 12px;"> {{ getProvinceFromPcode(modalAreaSelectedPCode) }}</span>
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1" style="font-size: 12px;">
                        <li v-for="(province, index) in modalAreaProvinces" v-bind:key="index" @click="clickRowProvince(province.code);">&nbsp;{{province.name_la+'/'+province.name_en}}&nbsp;</li>
                    </ul>
              </div>
          </div>
          </div>
          <hr>
          <!-- section2 -->
          <div style="width: 100%;">
          <span style="font-size: 12px;float: left;"><b>Question Area</b></span>
              <table class="table table-striped">
              <thead>
                <tr>
                  <th scope="col" style="width: 15%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">No.</th>
                  <th scope="col" style="width: 75%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">
                    <span>District</span>                  
                  </th>
                  <th scope="col" style="width: 10%;font-size: 12px;border:1px solid black;background-color: cornflowerblue;">
                    <input class="form-check-input" type="checkbox" v-model="isCheckAllDistrict" @change=onChangeCbAllDistrict($event)>
                  </th>
                </tr>
              </thead>
              <tbody >
                <tr v-for="(district, index) in modalAreaDistrictsInPv" v-bind:key="index">
                  <th scope="row" style="font:12px;border:1px solid black;">
                    {{index+1}}
                  </th>
                  <td style="padding:0px;border:1px solid black;">
                    {{ district.name_la+'/'+district.name_en }}
                  </td>
                  <td style="padding:0px;border:1px solid black;">
                    <input class="form-check-input" type="checkbox" v-model="district.isActive">
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-success" @click="clickOkChooseDistricts();">OK</button>
      </div>
    </div>
  </div>
</div>
        <div class="row text-center" style="padding: 0px 5px 0px 5px">
              <button type="submit" class="btn btn-danger" @click="$router.push('/home');" style="width:100%;" >
              <i class="fas fa-house"></i> Home
            </button>
        </div>
    </div>
    
</template>

<script>
import '@fortawesome/fontawesome-free/css/all.css'
import { Modal } from 'bootstrap'
import axios from 'axios';
import Global from './GlobalVariable';
import Service from './Service';

export default {
  name: 'SurveyPage',
  mixins: [Service],
  props: {
    msg: String
  },
  data() {
    return {
        
        questionsData:[],
        surveyGroupDdl:Global.surveyGroup,
        // {type1:"Normal Customer & Shop Dealer",type2:"FTTH Customer",type3:"Merchant M-money"},
        // selectedSurveyGroupType:0,
        selectedSurveyGroupData:{"id":-9999},
        modalRowNumber:"",
        modalQDetail:null,
        modalQDetailFlagAdd:false,
        modalQDetailFlagSwicthEdit:false,
        modalQDetailQuestionMsg:"",
        modalQDetailChoices:[],
        modalQDetailChoicesIdToDelete:[],
        modalQDetailProvince:[],
        modalQDetailProvinceToDel:[],
        modalQDetailQuestionId:null,
        modalQDetailQuestionStatus:null,
        modalArea:null,
        modalAreaFlagAdd:false,
        modalAreaProvinces:Global.provinces,
        modalAreaSelectedPCode:null,
        modalAreaDistrictsInPv:[],
        allDistrict:Global.districts,
        surveyObject:{},
        isCheckAllDistrict:false
    };
  },
  mounted:async function() {
    var vm = this;
    vm.modalQDetail = new Modal(document.getElementById('modalQDetail'));
    if(Global.provinces.length==0){
      vm.getProvinces();
    }
    if(Global.districts.length==0){
      vm.getDistricts();
    }


    
    vm.modalArea = new Modal(document.getElementById('modalArea'));

      var surveyGroupResult = await vm.getSurveyGroup();
      if(surveyGroupResult.status==200&&surveyGroupResult.statusText=="OK"&&surveyGroupResult.data.result){
        vm.surveyGroupDdl = surveyGroupResult.data.result;
      }
      if(Global.selectedSurveyGroupName){
        var defaultSurveyGroup = vm.surveyGroupDdl.filter(item => item.name_la == Global.selectedSurveyGroupName)
        vm.selectedSurveyGroupData = defaultSurveyGroup[0];
        vm.getQuestionsAndChoices(vm.selectedSurveyGroupData);
      }
  },
  methods: {
   verifyOtp: function(){
    this.$router.push("/home");
   },

  showPosition: function(position) {
    this.lat = position.coords.latitude;
    this.lng = position.coords.longitude;
  },
  showError:function(error) {
    switch(error.code) {
      case error.PERMISSION_DENIED:
        alert("User denied the request for Geolocation.");
        break;
      case error.POSITION_UNAVAILABLE:
        alert("Location information is unavailable.");
        break;
      case error.TIMEOUT:
        alert("The request to get user location timed out.");
        break;
      case error.UNKNOWN_ERROR:
        alert("An unknown error occurred.");
        break;
    }
  },
  clickSave:function(){
    var vm = this;
    var validateObject = vm.validateFormSaveUser();
      if(!validateObject.flag){
        vm.$swal.fire('Please prepare information to save!', validateObject.msg, 'error');
      }else{
        vm.$swal.fire({
          title: 'Do you want to send data?',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: 'Send',
          denyButtonText: `Cancel`,
        }).then((result) => {
          if (result.isConfirmed) {
            vm.saveData();
          } 
        });
      }
    },
    validateFormSaveUser:function(){
    var flag = true,
    vm = this,
    msg = "";
    if(!vm.modalQDetailQuestionMsg){
      flag = false;
      msg+= "<div style='float:left'><i class='fa-solid fa-pen-to-square' style='color:red'></i> Question message must be typing! </div><br>";
    }
    if(vm.modalQDetailChoices.length==0){
      flag = false;
      msg+= "<div style='float:left'><i class='fa-solid fa-pen-to-square' style='color:red'></i> Choice must be adding! </div><br>";
    }    
    // if(vm.modalQDetailProvince.length==0){
    //   flag = false;
    //   msg+= "<div style='float:left'><i class='fa-solid fa-pen-to-square' style='color:red'></i> Province area must be adding! </div><br>";
    // }
    return {"flag":flag,"msg":msg};
  },
   getQuestionsAndChoices: async function(groupData){
    var vm = this;
    var d = new Date();
    vm.startDate = d.getTime();

    // vm.selectedSurveyGroupType = custType;
    vm.selectedSurveyGroupData = groupData;
    if(!vm.surveyObject['surveyGroup'+vm.selectedSurveyGroupData.id]||vm.surveyObject['surveyGroup'+vm.selectedSurveyGroupData.id].length==0){
    vm.showLoading();
      return await axios.post(Global.backendPath+"question/getQuestionsAndChoices", {"custType":vm.selectedSurveyGroupData.id},
      {
            headers: {
            "Authorization": localStorage.getItem("token")
            }
      })
      // Global.userIdentify = 14749
      //Global.userName = VT4584
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"&&response.data.result){
          vm.surveyObject['surveyGroup'+vm.selectedSurveyGroupData.id]=response.data.result;
        }
      }).catch((error) => {
        vm.hideLoading();
        console.log(error);
        vm.isTokenExpire(error);
      });
    }
   },
   clickBtnAddQuestion:function(){
    var vm = this;
    var existingQuestion = vm.surveyObject['surveyGroup'+vm.selectedSurveyGroupData.id];
    vm.modalQDetailFlagSwicthEdit = null;
    vm.modalRowNumber = (existingQuestion&&existingQuestion.length?existingQuestion.length+1:1);
    vm.modalQDetailQuestionMsg = "";
    vm.modalQDetailChoices = [];
    vm.modalQDetailQuestionId = null;
    vm.modalQDetailQuestionStatus = true
    vm.modalQDetailProvince = [];
    vm.modalQDetailChoicesIdToDelete = [];
    vm.modalQDetailProvinceToDel = [];
    vm.modalQDetail.show();
  },
   clickRowQuestion:function(rowData,rowNumber){

    var vm = this;
    vm.modalQDetailFlagSwicthEdit = false;
    vm.modalRowNumber = rowNumber;
    vm.modalQDetailQuestionMsg = rowData.question_msg_la;
    vm.modalQDetailChoices = rowData.choices;
    vm.modalQDetailQuestionId = rowData.q_id;
    vm.modalQDetailQuestionStatus = rowData.status
    vm.modalQDetailProvince = [];
    vm.modalQDetailChoicesIdToDelete = [];
    vm.modalQDetailProvinceToDel = [];
    vm.modalQDetail.show();
    // vm.getQuestionArea(rowData.q_id)
    // this.myModal.hide();
   },

   getProvinces: async function(){
    var vm = this;
    vm.showLoading();
      return await axios.post(Global.backendPath+"area/getProvinces", {},
      {
            headers: {
            "Authorization": localStorage.getItem("token")
            }
      })
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"&&response.data.result){
          vm.modalAreaProvinces=response.data.result;
          Global.provinces=response.data.result;
        }
      }).catch((error) => {
        vm.hideLoading();
        console.log(error);
        vm.isTokenExpire(error);
      });
   },
   getDistricts: async function(){
    var vm = this;
    vm.showLoading();
      return await axios.post(Global.backendPath+"area/getDistricts", {},
      {
            headers: {
            "Authorization": localStorage.getItem("token")
            }
      })
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"&&response.data.result){
          vm.allDistrict=response.data.result;
          Global.districts = response.data.result;
        }
      }).catch((error) => {
        vm.hideLoading();
        console.log(error);
        vm.isTokenExpire(error);
      });
   },
   getProvinceFromPcode: function(provinceCode){
    var vm = this;
    if(provinceCode){
    var provinceAr = vm.modalAreaProvinces.filter(item => item.code === provinceCode)
    var provinceData = provinceAr[0];
      return provinceData.name_la+"/"+provinceData.name_en;
    }else{
      return "";
    }
   },
   getProvinceObjectFromPcode: function(provinceCode){
    var vm = this;
    if(provinceCode){
    var provinceAr = vm.modalAreaProvinces.filter(item => item.code === provinceCode)
    var provinceData = provinceAr[0];
      return provinceData;
    }else{
      return "";
    }
   },
   saveData: function(){
    var vm = this;
    vm.showLoading();
    var jsonRequest = {}
    jsonRequest.questionMsg = vm.modalQDetailQuestionMsg;
    jsonRequest.questionStatus = (vm.modalQDetailQuestionStatus=="true"||vm.modalQDetailQuestionStatus===true?1:0);
    jsonRequest.questionId = vm.modalQDetailQuestionId;
    jsonRequest.choiceIdArrayToDelete = vm.modalQDetailChoicesIdToDelete;
    jsonRequest.choiceArray = vm.modalQDetailChoices;
    jsonRequest.questionAreaIdArrayToDelete = vm.modalQDetailProvinceToDel;
    jsonRequest.questionAreaArray = vm.modalQDetailProvince;
    jsonRequest.selectedSurveyGroupType = vm.selectedSurveyGroupData.id
    

    axios.post(Global.backendPath+"question/saveQuestion", jsonRequest,
            {
              headers: {
              "Authorization": localStorage.getItem("token")
            }
      })
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"){
          vm.$swal.fire('Save Completed!', '', 'success');
          vm.modalQDetail.hide();
          vm.resetQuestionPage();          
          vm.getQuestionsAndChoices(vm.selectedSurveyGroupData);
        }else{
          vm.$swal.fire('Can not save question data!', '', 'error');
        }
      }).catch((error) => {
        vm.hideLoading();
        console.log(error);
        vm.isTokenExpire(error);
      });
   },
   resetQuestionPage: function(){
    var vm = this;
    vm.modalQDetailFlagSwicthEdit=false;
    vm.modalRowNumber="";
    vm.modalQDetailQuestionMsg="";
    vm.modalQDetailChoices=[];
    vm.modalQDetailChoicesIdToDelete=[];
    vm.modalQDetailProvince=[];
    vm.modalQDetailProvinceToDel=[];
    vm.modalQDetailQuestionId=null;
    vm.modalQDetailQuestionStatus=null;
    
    vm.surveyObject = {};
   },
   clickDeleteChoice: function(index,choiceId,choiceMessage){
    var vm = this;
    vm.$swal.fire({
      title: 'Do you want to remove choice "No.'+(index+1)+' '+choiceMessage+'"',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Yes',
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        vm.modalQDetailChoices.splice(index, 1);
        if(choiceId){
          vm.modalQDetailChoicesIdToDelete.push(choiceId);
        }
      }
    });
   },
   clickAddChoice: function(){
    var vm = this;
    vm.modalQDetailChoices.push({"q_id":vm.modalQDetailQuestionId});
   },
   clickDeleteProvince: function(index,areaObject){
    var vm = this;
    vm.$swal.fire({
      title: 'Do you want to remove Province "No.'+(index+1)+' '+areaObject.name_la+'/'+areaObject.name_en+'"',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Yes',
      denyButtonText: `No`,
    }).then((result) => {
      if (result.isConfirmed) {
        vm.modalQDetailProvince.splice(index, 1);
        if(areaObject.id){
          vm.modalQDetailProvinceToDel.push(areaObject.id);
        }
      }
    });
    
        
   

   },
   clickBtnAddProvince: function(){
    var vm = this;
    vm.modalAreaSelectedPCode = null
    vm.modalAreaDistrictsInPv = [];
    vm.modalAreaFlagAdd = true;
    vm.isCheckAllDistrict = false;
    vm.modalArea.show();
   },
   clickRowProvince: function(provinceCode,existingDistrictsId){
    var vm = this;
    vm.modalArea.show();
    vm.isCheckAllDistrict = false;
      if(vm.modalAreaFlagAdd){
      //*****Check wheater new selected province is dupplicate with exiting provinces in modal Question Detail or not?
      var result = vm.modalQDetailProvince.filter(district => district.province_code == provinceCode);
            if(result.length>0){
              vm.$swal.fire('Can not select province "'+vm.getProvinceFromPcode(provinceCode)+"\", it's duplicating with existing one!", '', 'error');
            }else{
              vm.setAreaData(provinceCode);
            }
      }else{
              vm.setAreaData(provinceCode,existingDistrictsId);
      }
    },
    setAreaData: function(provinceCode,existingDistrictsId){
      var vm = this;
          vm.modalAreaSelectedPCode = provinceCode;
      var districts = vm.allDistrict.filter(district => district.province_code == provinceCode);
          vm.modalAreaDistrictsInPv = vm.copyJsonObject(districts);
          //******existingDistrictsId come from click province in modal Question Detail 
          if(existingDistrictsId){
                var districtsIdArray = existingDistrictsId.split(",");
                for(var idx=0;idx<districtsIdArray.length;idx++){
                      var districtId = districtsIdArray[idx];
                      var currentDistricts = vm.modalAreaDistrictsInPv.filter(district => district.id == districtId);
                      currentDistricts[0].isActive = true;
                }
          }
   },
   getDistrictsById: async function(provinceCode){
    var vm = this;
    vm.showLoading();
    var jsonRequest = {};
    jsonRequest.questionId = vm.modalQDetailQuestionId;
    jsonRequest.provinceCode = provinceCode;
      return await axios.post(Global.backendPath+"area/getDistrictsById", jsonRequest,
      {
            headers: {
            "Authorization": localStorage.getItem("token")
            }
      })
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"&&response.data.result){
          var results = response.data.result;
          for(var idx=0;idx<results.length;idx++){
            var result = results[idx];
            if(result.status){
              var currentDistricts = vm.modalAreaDistrictsInPv.filter(district => district.id == result.district_id);
              currentDistricts[0].isActive = true;
            }

          }
        }
      }).catch((error) => {
        vm.hideLoading();
        console.log(error);
        vm.isTokenExpire(error);
      });
   },
   clickOkChooseDistricts: function(){
    var vm = this;
    var districsComma = "";
    for(var idx=0;idx<vm.modalAreaDistrictsInPv.length;idx++){
      var currentDistrict = vm.modalAreaDistrictsInPv[idx];
      if(currentDistrict.isActive){
        districsComma+=(districsComma!=""?",":"")+currentDistrict.id
      }
    }
    var existingProvince= vm.modalQDetailProvince.filter(item => item.province_code === vm.modalAreaSelectedPCode)
    if(existingProvince.length>0){
      existingProvince[0].districts_id = districsComma;
    }else{
      var provinceObject = vm.getProvinceObjectFromPcode(vm.modalAreaSelectedPCode);
      var newAreaData ={
      id:null,
      q_id:vm.modalQDetailQuestionId,
      province_code: vm.modalAreaSelectedPCode,
      districts_id: districsComma,
      province_id:provinceObject.id,
      name_en: provinceObject.name_en,
      name_la: provinceObject.name_la}
      vm.modalQDetailProvince.push(newAreaData);
    }
    vm.modalArea.hide();
   },
   clickBtnDeleteQuestion: function(){
    var vm = this;
      vm.$swal.fire({
        title: 'Do you want to delete this Question?',
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: 'Confirm',
        denyButtonText: `Cancel`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          vm.deleteQuestionData();
        }
      });
   },
   deleteQuestionData: async function(){
    var vm = this;
    vm.showLoading();
      return await axios.post(Global.backendPath+"question/deleteQuestion", {"id":vm.modalQDetailQuestionId},
      {
            headers: {
            "Authorization": localStorage.getItem("token")
            }
      })
      .then((response) => {
        vm.hideLoading();
        if(response.status==200&&response.statusText=="OK"){
          vm.$swal.fire('Delete this question completed!', '', 'success');
          vm.resetQuestionPage();
          vm.getQuestionsAndChoices(vm.selectedSurveyGroupData);
        }else{
          vm.$swal.fire("Can't delete this question", '', 'error');
        }
      }).catch((error) => {
        vm.hideLoading();
        console.log(error);
        vm.$swal.fire("Can't delete this question", '', 'error');
        vm.isTokenExpire(error);
      });
   },
   onChangeCbAllDistrict(){
    var vm = this;
        if(vm.isCheckAllDistrict){
          vm.modalAreaDistrictsInPv.forEach(district => district.isActive=true);
        }else{
          vm.modalAreaDistrictsInPv.forEach(district => district.isActive=false);
        }
    }


},
};
</script>

<style scoped>
.otp-keypad {
  max-width: 50%;
  margin: 0 auto;
}

.otp-keypad-button {
  font-size: 1.5rem;
  font-weight: bold;
  border-radius: 50%;
  height: 60px;
  width: 60px;
  line-height: 60px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  background-color: #f1f1f1;
  border: none;
  outline: none;
  color: #333;
}

.otp-keypad-empty-space {
  height: 60px;
  width: 60px;
  background-color: transparent;
}

.nav-link.active {
  background-color: gray;
}
</style>
